// ============================================
// モジュール読み込み
// ============================================
import { viewport } from './libs/switchViewport';
import { inImg, inViewAnm, lenisPageScroll, titleAnm, topMv } from './libs/Scroll';
import { drawer, fixedHeader, megaMenu } from './libs/Header';
import { addAutoFunc, confirmForm } from './libs/Form';
import { topImg } from './libs/Img';
// import { accordionFunc } from './libs/Accordion';
// import { blogSort } from './libs/Blog';
// import { createIndex } from './libs/CreateIndex';
// import { articleTable, ScrollHintFunc } from './libs/ScrollHint';
// import { modal } from './libs/Modal';
// import { slider } from './libs/Slider';
// import { tabFunc } from './libs/Tab';

// 実行
// ==========================
window.addEventListener('DOMContentLoaded', () => {
  viewport();
  fixedHeader();
  drawer();
  megaMenu();
  // createIndex();
  // addAutoFunc();
  confirmForm();
  lenisPageScroll();
  // accordionFunc();
  titleAnm();
  // articleTable();
  // ScrollHintFunc();
  // tabFunc();
});

window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
  topMv();
  inImg();
  topImg();
  inViewAnm();
  // modal();
  // blogSort();
  // slider();
});
